// layout (each page): top
export const AD_SLOT_GLOBAL_TOP = 'sw-hb'

// home page: CategoryWide CMS component
export const AD_SLOT_HOMEPAGE_WIDE = 'hp-b1'
// home page: CategorySmall CMS component
export const AD_SLOT_HOMEPAGE_SMALL_1 = 'hp-b2'
export const AD_SLOT_HOMEPAGE_SMALL_2 = 'hp-b3'
// home page: EyecatcherSmart CMS component
export const AD_SLOT_HOMEPAGE_SMART = 'hp-smart'

// category page: CategoryWide CMS component
export const AD_SLOT_CATEGORY_WIDE = 'cp-b1'
// category page: CategorySmall CMS component
export const AD_SLOT_CATEGORY_SMALL_1 = 'cp-b2'
export const AD_SLOT_CATEGORY_SMALL_2 = 'cp-b3'

// search page (brand product listing): top
export const AD_SLOT_SEARCH_BRAND_TOP = 'ms-b1'
// search page (category product listing): top
export const AD_SLOT_SEARCH_CATEGORY_TOP = 'cpl-b1'
// search page: between search results
export const AD_SLOT_SEARCH_HITS_1 = 'pl-b1'
export const AD_SLOT_SEARCH_HITS_2 = 'pl-b2'

// product page: cross sell-widget
export const AD_SLOT_PDP_CROSSSELL = 'pds-b1'
// product page: RX message
export const AD_SLOT_PDP_RX = 'pds-b1-rx'
